import ServicesSection from '../Components/Sections/Services.Section';
import {Helmet} from '@dr.pogodin/react-helmet';
import React from 'react';

const ServicesPage: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>Services - Lesia K Slot 2D Art Development</title>
                <link rel="canonical" href={`https://lesia-k.com/services`}/>

                <meta name="description"
                      content="Explore our range of services in 2D art development for slot games. From concept design to final assets, we deliver high-quality visuals tailored to your project's needs."/>
                <meta name="keywords"
                      content="2D art services, slot game art, concept design, game asset creation, Lesia K services"/>
                <meta property="og:title" content="Services - Lesia K Slot 2D Art Development"/>
                <meta property="og:description"
                      content="Explore our range of services in 2D art development for slot games. From concept design to final assets, we deliver high-quality visuals tailored to your project's needs."/>
                <meta property="og:url" content="https://lesia-k.com/services"/>
                <meta name="twitter:title" content="Our Services - Lesia K Slot 2D Art Development"/>
                <meta name="twitter:description"
                      content="Explore our range of services in 2D art development for slot games. From concept design to final assets, we deliver high-quality visuals tailored to your project's needs."/>
            </Helmet>
            <ServicesSection/>
        </>
    )
}

export default ServicesPage;
